import { render, staticRenderFns } from "./TreatmentCompletedEmailTemplate.vue?vue&type=template&id=7ffedfea&scoped=true"
import script from "./TreatmentCompletedEmailTemplate.vue?vue&type=script&lang=js"
export * from "./TreatmentCompletedEmailTemplate.vue?vue&type=script&lang=js"
import style0 from "./TreatmentCompletedEmailTemplate.vue?vue&type=style&index=0&id=7ffedfea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffedfea",
  null
  
)

export default component.exports